<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <info-top-right class="card-header" :application="EvaluationForm.application"></info-top-right>

            <evaluation-wizard :is-editable="EvaluationForm.isEditable">
              <template slot="header">
                <h4 class="text-left" slot="title">
                  {{ $t('medium_grant_ev.diligence__title') }}
                </h4>
              </template>

              <evaluation-wizard-tab>
                <page1></page1>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page2></page2>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page3></page3>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page4></page4>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page5></page5>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page6></page6>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page7></page7>
              </evaluation-wizard-tab>

              <evaluation-wizard-tab>
                <page8></page8>
              </evaluation-wizard-tab>

            </evaluation-wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import Page2 from './Page2';
  import Page3 from './Page3';
  import Page4 from './Page4';
  import Page5 from './Page5';
  import Page6 from './Page6';
  import Page7 from './Page7';
  import Page8 from './Page8';
  import InfoTopRight from '../InfoTopRight';
  import {EvaluationWizard, EvaluationWizardTab} from '@/components';
  import {EvaluationForm} from "@/services";

  export default {
    components: {
      EvaluationWizard,
      EvaluationWizardTab,
      Page1,
      Page2,
      Page3,
      Page4,
      Page5,
      Page6,
      Page7,
      Page8,
      InfoTopRight
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>